export const calculate_tval_5_22 = (row) => {
    if (row.tval_avg_5 !== undefined && row.tval_avg_22 !== undefined) {
        let tval_avg = {};

        ['stock_rights', 'stock_rights_fund', 'fund_fixed'].forEach((stock) => {
            if (row.tval_avg_5[stock] < row.tval_avg_22[stock]) {
                if (row.yesterday_tval_avg_5[stock] >= row.yesterday_tval_avg_22[stock]) {
                    tval_avg[stock] = 'پایین'
                } else {
                    tval_avg[stock] = '_'
                }
            } else if (row.tval_avg_5[stock] > row.tval_avg_22[stock]) {
                if (row.yesterday_tval_avg_5[stock] <= row.yesterday_tval_avg_22[stock]) {
                    tval_avg[stock] = 'بالا'
                } else {
                    tval_avg[stock] = '+'
                }
            }
        })
        row['tval_5_22'] = tval_avg
    }
    return row
}

export const calculate_tval_5_60 = (row) => {
    if (row.tval_avg_5 !== undefined && row.tval_avg_60 !== undefined) {
        let tval_avg = {};

        ['stock_rights', 'stock_rights_fund', 'fund_fixed'].forEach((stock) => {
            if (row.tval_avg_5[stock] < row.tval_avg_60[stock]) {
                if (row.yesterday_tval_avg_5[stock] >= row.yesterday_tval_avg_60[stock]) {
                    tval_avg[stock] = 'پایین'
                } else {
                    tval_avg[stock] = '_'
                }
            } else if (row.tval_avg_5[stock] > row.tval_avg_60[stock]) {
                if (row.yesterday_tval_avg_5[stock] <= row.yesterday_tval_avg_60[stock]) {
                    tval_avg[stock] = 'بالا'
                } else {
                    tval_avg[stock] = '+'
                }
            }
        })
        row['tval_5_60'] = tval_avg
    }
    return row
}

export const calculate_tval_22_60 = (row) => {
    if (row.tval_avg_22 !== undefined && row.tval_avg_60 !== undefined) {
        let tval_avg = {};

        ['stock_rights', 'stock_rights_fund', 'fund_fixed'].forEach((stock) => {
            if (row.tval_avg_22[stock] < row.tval_avg_60[stock]) {
                if (row.yesterday_tval_avg_22[stock] >= row.yesterday_tval_avg_60[stock]) {
                    tval_avg[stock] = 'پایین'
                } else {
                    tval_avg[stock] = '_'
                }
            } else if (row.tval_avg_22[stock] > row.tval_avg_60[stock]) {
                if (row.yesterday_tval_avg_22[stock] <= row.yesterday_tval_avg_60[stock]) {
                    tval_avg[stock] = 'بالا'
                } else {
                    tval_avg[stock] = '+'
                }
            }
        })
        row['tval_22_60'] = tval_avg
    }
    return row
}

export const calculate_ao = (row) => {
    if (row.ao >= row.yesterday_ao) {
        row['new_ao'] = 'سبز'
    }
    row['new_ao'] = 'قرمز'
    return row
}

export const calculate_score = (row) => {
    let temp = {};
    if (row.plp_range_numbers !== undefined) {
        ['stock_rights', 'stock_rights_fund', 'fund_fixed'].forEach((stock) => {

            const totalStockNumbers = row.plp_range_numbers[stock].reduce((a, b) => a + b, 0)
            const weightForEachRange = row.plp_range_numbers[stock].map((number, index) => {
                if (index >= 6) {
                    index += 1
                }
                return (number / totalStockNumbers) * 100 * (index - 6)
            })

            const sumWeights = weightForEachRange.reduce((a, b) => a + b, 0)
            const finalScore = Math.round(sumWeights / 15)
            temp[stock] = finalScore
        })
        row['score'] = temp
    }
    return row
}